import { ChangeDetectionStrategy, Component } from '@angular/core';

import { InfoPageSkeletonComponent } from '@tiltgroup/web-components';

@Component({
  selector: 'lt-unauthorized',
  imports: [InfoPageSkeletonComponent],
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnauthorizedComponent {}
